<template>
  <div class="pg-pc" :class="star">
    <div class="logo"></div>
    <div class="name"></div>
    <a class="home" href="https://yszt.ztgame.com/index.shtml" target="_blank"></a>
    <a class="download" href="https://yszt.ztgame.com/download/" target="_blank"></a>
    <div class="qrcode">
      <vue-qr :text="addr" class="code" margin="12" :backgroundColor="'#fff7f4'" :colorLight="'#fff7f4'"></vue-qr>
      <div class="title"></div>
    </div>
    <!-- <div class="text">请使用手机微信扫码访问</div> -->
  </div>
</template>
<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import vueQr from 'vue-qr'
import { isWeiXin, getParameterByName, isAndroid, setCookie, getCookie, deleteCookie } from "~/tools/utils";


export default {
  components: {
    vueQr
  },
  data() {
    return {
      star: getParameterByName('star'),
      addr: location.href
    }
  },
  mounted() {
    document.querySelector(".pg-loading").style.display = "none";
    store.commit(types.SHOW_LOADING, false);
  }
}
</script>

<style lang="stylus" scoped>
  .pg-pc
    width 100%
    height 100vh
    background-image url('./images/pc/bg.png')
    background-position top center
    background-size cover
    background-repeat no-repeat
    display flex
    justify-content center
    align-items center
    background-color rgba(0,0,0,0.75)
    .home
      position absolute
      top 0.3rem
      right 0.52rem
      width 1.34rem
      height 0.36rem
      background:url(./images/pc/home.png) no-repeat;
      background-size 100% 100%
      cursor pointer
      &:hover
        filter brightness(1.2)
    .download
      position absolute
      top 0.3rem
      right 2.02rem
      width 1.34rem
      height 0.36rem
      background:url(./images/pc/download.png) no-repeat;
      background-size 100% 100%
      cursor pointer
      &:hover
        filter brightness(1.2)
    .name
      position absolute
      top 5.93rem
      left 50%
      margin-left 5.38rem
      width 1.88rem
      height 1.78rem
      background:url(./images/pc/icon.png) no-repeat;
      background-size 100% 100%
      animation slideInRight 1s ease
    .logo
      background-image url('./images/pc/logo.png')
      width 1.59rem
      height 1.48rem
      background-size contain
      position absolute
      left 0.82rem
      top 0.37rem
    .qrcode
      background-image url('./images/pc/slogan.png')
      background-repeat no-repeat
      background-size contain
      width 5.46rem
      height 4.8rem
      position absolute
      left 50%
      margin-left -1.38rem
      top 4.42rem
      padding-top 0.17rem
      padding-left: 1.34rem
      .title
        background-image url('./images/pc/title.png')
        background-size contain
        position absolute
        width 3.29rem
        height 1rem
        top 2.33rem
        left 0.84rem
      .code
        width 2.3rem
        height 2.3rem
    .text
      width 100%
      font-size 22px
      text-align center
</style>
